import { injectable } from "inversify";
import SettingsRepository from "../../../domain/repositories/settings.repository";
import getCurrentThemeApiImpl from "./impl/get_current_theme.api.impl";
import setCurrentThemeApiImpl from "./impl/set_current_theme.api.impl";

@injectable()
class SettingsRepositoryImpl implements SettingsRepository {
    attrName = "data-bs-theme";
    storageKey = "k-data-bs-theme";

    getCurrentTheme = (): string => getCurrentThemeApiImpl(this.storageKey, this.attrName);
    setCurrentTheme = (theme: string): void => setCurrentThemeApiImpl({ theme, keyLocalStorage: this.storageKey, bodyAttr: this.attrName });
}

export default SettingsRepositoryImpl;